import { useEffect, useState } from "react";
import { apiUrl } from "../utils/api";
import "../style/Quiz.css";

const SITE_CONTENT_API_URL = process.env.REACT_APP_SITE_CONTENT_API_URL
    || apiUrl("site_content_public.php");

export default function InformationPage({ page, language, text }) {
    const isAboutPage = page === "about";
    const [content, setContent] = useState("");
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const controller = new AbortController();
        setIsLoading(true);
        setError("");
        fetch(`${SITE_CONTENT_API_URL}?language=${encodeURIComponent(language)}`, {
            signal: controller.signal
        })
            .then(async (response) => {
                const result = await response.json();
                if (!response.ok) {
                    throw new Error(result.error || `Site content API returned HTTP ${response.status}`);
                }
                const description = isAboutPage
                    ? result.aboutDescription
                    : result.supportDescription;
                if (typeof description !== "string") {
                    throw new Error("Site content API returned invalid content");
                }
                setContent(description);
            })
            .catch((requestError) => {
                if (requestError.name !== "AbortError") {
                    console.error("Failed to load site information:", requestError);
                    setError(text.siteContentLoadError);
                }
            })
            .finally(() => {
                if (!controller.signal.aborted) {
                    setIsLoading(false);
                }
            });

        return () => controller.abort();
    }, [isAboutPage, language, text.siteContentLoadError]);

    return (
        <main className="information-page">
            <span className="quiz-label">
                {isAboutPage ? text.aboutLink : text.supportLink}
            </span>
            <h1>{isAboutPage ? text.aboutTitle : text.supportTitle}</h1>
            {isLoading ? (
                <p role="status">{text.siteContentLoading}</p>
            ) : error ? (
                <p role="alert">{error}</p>
            ) : (
                <p>{content}</p>
            )}
        </main>
    );
}
